export default __webpack_public_path__ + "static/media/35A32A_1_0-74d5c0393a97b044fad1f10d7a06260a.481247db.woff2";